import compact from 'lodash/compact'
import { useContext } from 'react'

import { NavLinkClickProperties } from '@Analytics/ampli'
import { MetadataContext } from '@Globals/Metadata'
import { useTranslation } from '@Globals/Translations'

export interface CustomerSupportData {
  analytics?: NavLinkClickProperties
  href: string
  newTab: boolean
  title: string
}

export const useCustomerSupportData = ({ sourceID }: { sourceID?: string }) => {
  const { t } = useTranslation()
  const useNewReturnFlow = true
  const { cmsData, storeURL } = useContext(MetadataContext)

  const faq: CustomerSupportData | undefined = cmsData.urls.faq?.url && cmsData.urls.faq?.title
    ? {
      analytics: {
        dest_page_type: cmsData.urls.faq.type,
        dest_page_type_id: cmsData.urls.faq.id,
        source_id: sourceID,
      },
      href: cmsData.urls.faq.url,
      newTab: false,
      title: cmsData.urls.faq.title,
    }
    : undefined

  const returnsLogin: CustomerSupportData = useNewReturnFlow
    ? {
      analytics: {
        dest_page_type: cmsData.urls.returns?.type,
        dest_page_type_id: cmsData.urls.returns?.id,
        source_id: sourceID,
      },
      href: cmsData.urls.returns?.url || storeURL('returns'),
      newTab: false,
      title: cmsData.urls.returns?.title || t('footer:NAV_PAGE_CREATE_RETURN'),
    }
    : {
      analytics: {
        dest_page_type: 'other',
        dest_page_type_id: 'returns-login',
        source_id: sourceID,
      },
      href: storeURL('returns/action/login'),
      newTab: false,
      title: t('footer:NAV_PAGE_CREATE_RETURN'),
    }

  const about: CustomerSupportData | undefined = cmsData.urls.aboutUs?.url
    ? {
      analytics: {
        dest_page_type: cmsData.urls.aboutUs?.type,
        dest_page_type_id: cmsData.urls.aboutUs?.id,
        source_id: sourceID,
      },
      href: cmsData.urls.aboutUs.url,
      newTab: false,
      title: cmsData.urls.aboutUs?.title || t('footer:NAV_PAGE_ABOUT'),
    }
    : undefined

  const career: CustomerSupportData = {
    analytics: {
      dest_page_type: 'careers',
      dest_page_type_id: 'careers',
      source_id: sourceID,
    },
    href: 'https://career.trendhim.com',
    newTab: true,
    title: t('footer:CAREERS_LABEL'),
  }

  return { customerSupportData: compact([faq, returnsLogin, about, career]), customerSupportDataMap: { faq, returnsLogin, about, career } }
}
